export default "__VITE_ASSET__D7p1SiX4__"